"use client";
import React from 'react'
import worldmap from '../images/Home/worldmap_nasa.jpg';
import worldmap_360 from '../images/Home/worldmap_nasa_360.jpg';
import worldmap_tab from '../images/Home/worldmap_nasa_tab.jpg';
import worldmap2x from '../images/Home/worldmap_nasa@2x.jpg';
import Image from 'next/image';
const HomeMap = () => {
  return (
    <div className='container max-w-screen-xl mx-auto pt-1 lg:pt-3 min-h-[28.75rem] md:min-h-[30.75rem] lg:min-h-[40.75rem] ' style={{'bacgroundColor':'white'}}>
       
                {/* <Image src={worldmap} alt="Nighttime global map showing city lights from space" 
                placeholder="blur"
                         srcSet={`${worldmap} 1x, ${worldmap2x} 2x`}/> */}

              <picture className='relative w-full  flex h-auto'>
                    <source media="(max-width: 600px)" srcSet={worldmap_360.src} />
                {/* Tablet (426px to 899px) */}
                <source media="(min-width: 601px) and (max-width: 900px)" srcSet={worldmap_tab.src} />
                <source media="(min-width: 901px)" srcSet={`${worldmap.src} 1x, ${worldmap.src} 2x`} />
                      <img
                        src={worldmap2x.src}
                        alt="Nighttime global map showing city lights from space"
                        width={3840}
                        height={900}
                        className='block w-full  lg:h-auto object-cover object-center'
                      />
                    </picture>
       
        <div className=' text-justify text-xl  italic lg:my-3 px-4 sm:px-4 lg:px-0'>
            The world map shown above is the result of a series of photographs taken by one of NASA&apos;s space satellites during the night and was released to the world in the winter of 2000. Around the same time Ashlok had just turned an year old, and the photograph got etched into our memories as an inspiration, depicting the power, reach and beauty of electricity.
        </div>
         {/* hide content */}
        <div>
            <p className="sr-only">maintenance free earthing</p>
            <p className="sr-only">earthing</p>
            <p className="sr-only">electrode</p>
            <p className="sr-only">earthing electrode</p>
        </div>
    </div>
  )
}
export default HomeMap